import { useState } from 'react'
import PropTypes from 'prop-types'
import { Bar } from 'victory'
import AssociatedContactTooltip from './AssociatedContactTooltip'
import AssociatedContactIcon from './AssociatedContactIcon'

const AssociatedContactBar = props => {
  const {
    datum: { contact },
    heightPerContact,
    style,
    selectedContactId,
  } = props

  const [hoveredContact, setHoveredContact] = useState(null)

  const handleOpen = () => {
    const { id } = contact
    setHoveredContact(id)
  }

  const handleClose = () => setHoveredContact(null)

  const isCurrentContact = contact.id === selectedContactId
  const isClickable = !isCurrentContact && contact.id === hoveredContact && contact.inScope

  return (
    <AssociatedContactTooltip contact={contact} onOpen={handleOpen} onClose={handleClose}>
      <g style={{ cursor: contact.inScope && !isCurrentContact ? 'pointer' : 'default' }}>
        <Bar {...props} barWidth={heightPerContact} style={{ ...style, fill: 'transparent' }} />
        <g
          data-testid={
            isCurrentContact
              ? `associated-contact-${contact.id}-bar-container-current`
              : `associated-contact-${contact.id}-bar-container`
          }
        >
          <Bar {...props} />
        </g>
        <AssociatedContactIcon
          {...props}
          isCurrentContact={isCurrentContact}
          isClickable={isClickable}
          iconSize={heightPerContact}
        />
      </g>
    </AssociatedContactTooltip>
  )
}
AssociatedContactBar.propTypes = {
  datum: PropTypes.object,
  heightPerContact: PropTypes.number,
  style: PropTypes.object,
  selectedContactId: PropTypes.number,
}

export default AssociatedContactBar
